import './deviceSelectDialog.scss';
import React from 'react';
import { SnackBar, Modal } from '@umu/umu-design';
const { confirm } = Modal;
import { getData, lang, statistic } from '@umu/umu-util';
import { MediaDeviceSelector, IPermissionError, EPermissionError } from '../@mediaDeviceSelector/mediaDeviceSelector';

export function compareBrowserVersion(version1: string, version2: string) {
    const v1 = version1.split('.');
    const v2 = version2.split('.');
    for (let i = 0; i < v1.length || i < v2.length; i++) {
        let x = 0;
        let y = 0;
        if (i < v1.length) {
            x = parseInt(v1[i], 10);
        }
        if (i < v2.length) {
            y = parseInt(v2[i], 10);
        }
        if (x > y) {
            return 1;
        }
        if (x < y) {
            return -1;
        }
    }
    return 0;
}

async function getUserMedia(callback: (result: any) => void) {
    const constraints = {
        audio: true,
        video: true,
    };

    let stream: MediaStream | null = null;

    try {
        stream = await navigator.mediaDevices.getUserMedia(constraints);
        callback(null);
    } catch (err) {
        callback(err);
    }

    setTimeout(() => {
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
        }
    }, 100);
}

const openPermissionDialog = function (error: any, onStartRecord: (audioId: string, videoId: string) => void, config?: { buttonLang?: string }) {
    let permissionError: IPermissionError = { name: EPermissionError.NONE, message: '' };
    if (error) {
        permissionError = { name: error.name, message: error.message };
    }

    confirm({
        centered: true,
        closable: true,
        width: '4.68rem',
        title: lang('录制设置'),
        wrapClassName: 'record-device-setting',
        maskClosable: false,
        cancelText: '',
        okText: '',
        content: <MediaDeviceSelector onStartRecord={onStartRecord} permissionError={permissionError} config={config}/>,
    });
};

export const selectMediaDevice = async function (handleRecordStart: (audioId: string, videoId: string) => void, config?: { buttonLang?: string}) {
    const browserSupportMap: any = {
        chrome: {
            pc: '42.0.0',
            mobile: '42.0.0',
        },
        firefox: {
            pc: '45.0.0',
            mobile: '45.0.0',
        },
        safari: {
            pc: '15.6.0',
            mobile: '15.7.0',
        },
        edge: {
            pc: '18.0.0',
            mobile: '18.0.0',
        },
    };

    // 检查浏览器兼容性
    const browserInfo = getData(statistic, 'browserInfo') || {};
    const browserName = browserInfo.appName;
    const browserNameLowerCase = browserName.toLowerCase();
    let isSupportVersion = false;
    if (browserSupportMap[browserNameLowerCase] && browserSupportMap[browserNameLowerCase].pc) {
        isSupportVersion =
            compareBrowserVersion(browserInfo.appVersion, browserSupportMap[browserNameLowerCase].pc) >= 0;
    }

    if (!isSupportVersion) {
        SnackBar.show(
            lang('目前仅支持使用Chrome浏览器76及以上版本在线录制视频作业，请更换浏览器或使用 UMU App 操作。'),
        );
        return;
    }

    getUserMedia((result: any) => {
        openPermissionDialog(result, handleRecordStart, config);
    });
};
